import React, { createContext, useEffect, useState, useContext } from "react";


interface User {
  id: number;
  nome: string;
  email: string;
}

interface AuthContextData {
  logado: boolean;
  usuario: User | null;
  loginSession: (userData: User, token: string) => void;
  logoutSession: () => void;
  loading: boolean;
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

export const AuthProvider = ({ children }: any) => {
    const [usuario, setUsuario] = useState<User | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const recoveredUser = localStorage.getItem("@Sergipanidade:user");
        const token = localStorage.getItem("@Sergipanidade:token");

        if (recoveredUser && token) {
            if(recoveredUser === "undefined" || token === "undefined"){
                localStorage.removeItem("@Sergipanidade:user");
                localStorage.removeItem("@Sergipanidade:token");
                setUsuario(null);
            } else {
                setUsuario(JSON.parse(recoveredUser));
            }
        }
        setLoading(false);
    }, []);

    const loginSession = (usuario: User, token: string) => {
        if(!usuario || !token) return;
        if(usuario === undefined) return;
        localStorage.setItem("@Sergipanidade:user", JSON.stringify(usuario));
        localStorage.setItem("@Sergipanidade:token", token);
        setUsuario(usuario);
    }

    const logoutSession = () => {
        localStorage.removeItem("@Sergipanidade:user");
        localStorage.removeItem("@Sergipanidade:token");
        setUsuario(null);
    }

    return (
        <AuthContext.Provider value={{
            logado: !!usuario,
            usuario,
            loginSession,
            logoutSession,
            loading
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);